export default __webpack_public_path__ + "static/media/Scholar's Sash of the Moon.8537704c.jpg";